var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useAuth } from "@tenderd/track-web-utils";
import { useEffect, useState } from "react";
import { useGroupService } from "./GroupServiceProvider";
export var GroupPermission;
(function (GroupPermission) {
    GroupPermission["None"] = "none";
    GroupPermission["Read"] = "read";
    GroupPermission["Write"] = "write";
    GroupPermission["Admin"] = "admin";
})(GroupPermission || (GroupPermission = {}));
export var getPermissionsForUser = function (project, user, account) {
    if (project.account_ref.id === account.id && account.doc.admin_users && account.doc.admin_users[user.doc.email]) {
        return GroupPermission.Admin;
    }
    if (project.access && project.access[user.doc.email]) {
        if (project.access[user.doc.email].admin)
            return GroupPermission.Admin;
        if (project.access[user.doc.email].edit)
            return GroupPermission.Write;
        if (project.access[user.doc.email].view)
            return GroupPermission.Read;
        return GroupPermission.None;
    }
    return GroupPermission.None;
};
export var useGroupPermissions = function () {
    var _a = __read(useState(GroupPermission.Read), 2), permission = _a[0], setPermission = _a[1];
    var _b = useAuth(), user = _b.user, account = _b.account;
    var groupService = useGroupService();
    useEffect(function () {
        if (user && account && groupService.group) {
            setPermission(getPermissionsForUser(groupService.group.doc, user, account));
        }
    }, [user, groupService.group, account]);
    return permission;
};
